import React from "react"
import { graphql } from "gatsby"
import parse from "html-react-parser"
import StructuredText from "../custom-structured-text-renderer"
import { Link } from "../../../../plugins/gatsby-plugin-atollon"
import gsap from "gsap"
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { ArrowDown } from "../../icons"

gsap.registerPlugin(ScrollTrigger);

const ValueBlock = ({ title, subtitle, richContent, items, link, slug, culturePage }) => {
  const elementRef = React.useRef(null)

  React.useEffect(() => {
    const line = elementRef.current?.querySelectorAll('.line');

    ScrollTrigger.create({
      trigger: '.value-block__bottom',
      start: "top bottom",
      onEnter: () => {
        line.forEach((el) => el.classList.add('is-inview'))
      },
    });

    return () => {
    };
  }, [slug]);


  const renderValues = () => (
    <>
      {Array.from(
        { length: Math.ceil(items.length / 4) },
        (_, index) => (
          <div key={index} className="value-block__items">
            <div className={`line line--horizon line--top ${index % 2 ? 'center-left' : 'center-right'}`}></div>
            <div className={`line line--horizon line--middle ${index % 2 ? 'center-right' : 'center-left'}`}></div>
            <div className={`line line--horizon line--bottom ${index % 2 ? 'center-right' : 'center-left'}`}></div>
            {items.slice(index * 4, index * 4 + 4).map((el, i) => (
              <div className={`value-block__item value-block__item--${i}`} key={i}>
                <div className={`line line--vertical ${index % 2 ? "center-top" : "center-bottom"}`}></div>
                <div className="value-block__item--content">
                  {el.value && <h3>{parse(el.value)}</h3>}
                  {el.label && <StructuredText data={el.label} />}
                </div>
              </div>
            ))}
          </div>
        )
      )}
    </>
  )

  return (
    <section className="value-block">
      <div className="value-block__inner">
        <div className="value-block__wrapper" ref={elementRef}>
          <div className="line line--vertical center-bottom"></div>
          <div className="value-block__top">
            {subtitle && 
              <div className='value-block__top--subtitle'>
                <h3>{parse(subtitle)}</h3>
                {culturePage && 
                  <button 
                    onClick={() => {
                      const target = document.getElementById('available-roles');
                      const headerOffset = 78; // Adjust for your header height
                      const elementPosition = target.getBoundingClientRect().top + window.scrollY;
                      const offsetPosition = elementPosition - headerOffset;

                      window.scrollTo({
                        top: offsetPosition,
                        behavior: 'smooth',
                      });
                    }}
                    className='btn btn--border-white' >Available Roles <ArrowDown/>
                  </button> 
                }
              </div>
            }
            
            <div className='value-block__top--title'>
              {title && <h2>{parse(title)}</h2> }
              {culturePage && 
                <button 
                  onClick={() => {
                    const target = document.getElementById('available-roles');
                    const headerOffset = 78; // Adjust for your header height
                    const elementPosition = target.getBoundingClientRect().top + window.scrollY;
                    const offsetPosition = elementPosition - headerOffset;

                    window.scrollTo({
                      top: offsetPosition,
                      behavior: 'smooth',
                    });
                  }}
                  className='btn btn--border-white' >Available Roles <ArrowDown/>
                </button> 
              }
            </div>
          </div>
          <div className="value-block__bottom">
            <div className="line line--horizon center-left"></div>
            {richContent && (
                <div className="value-block__content">
                  {<StructuredText data={richContent} />}
                </div>
              )}

            <div className="value-block__clients">
              {renderValues()}
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default ValueBlock

export const query = graphql`
  fragment ValueBlockProps on DatoCmsValueBlock {
    ... on DatoCmsValueBlock {
      id
      title
      subtitle
      richContent {
        value
      }
      items {
        value
        label {
          value
        }
      }
      culturePage
    }
  }
`